export const BILLING_CRITICAL_PERCENT = 15;
